<!-- BEGIN: Left Aside -->
<div
  #asideMenuOffcanvas
  class="aside aside-left d-flex flex-column flex-row-auto"
  [ngClass]="asideClasses"
  id="kt_aside"
>
  <!-- begin:: Brand -->
  <kt-brand [viewLogoFun]="asideLogoFun"></kt-brand>
  <!-- end:: Brand -->

  <!-- BEGIN: Aside Menu -->
  <div class="aside-menu-wrapper flex-column-fluid" id="kt_aside_menu_wrapper">
    <div
      #asideMenu
      ktMenu
      [options]="menuOptions"
      id="kt_aside_menu"
      class="aside-menu"
      style="max-height: 97vh; overflow-y: scroll"
      [ngClass]="htmlClassService.getClasses('aside_menu', true)"
    >
      <ul class="menu-nav" [ngClass]="htmlClassService.getClasses('aside_menu_nav', true)">
        <ng-container [ngTemplateOutlet]="menuListTemplate"></ng-container>
      </ul>
    </div>
  </div>
  <div
    class="aside-footer d-flex flex-column align-items-center flex-column-auto bg-white text-wrap text-center py-4"
  >
    <div class="text-dark order-2 order-md-1">
      <span class="menu-icon font-weight-bold text-muted"> &copy; {{ today | date : 'yyyy' }}</span>
      <a
        *ngIf="viewLink && !theme?.minimized"
        href="https://www.medidohealth.com/"
        target="_blank"
        class="menu-text text-dark-75 text-hover-primary ml-2"
      >
        Medido Health LLC</a
      >
    </div>
  </div>
  <!-- END: Aside Menu -->
</div>
<!-- END: Left Aside -->

<ng-template #menuListTemplate>
  <ng-container *ngFor="let child of menuAsideService.menuList$ | async">
    <ng-container
      *ngIf="child.section"
      [ngTemplateOutlet]="menuItemSectionTemplate"
      [ngTemplateOutletContext]="{ item: child }"
    ></ng-container>
    <ng-container
      *ngIf="child.separator"
      [ngTemplateOutlet]="menuItemSeparatorTemplate"
      [ngTemplateOutletContext]="{ item: child }"
    ></ng-container>
    <ng-container
      *ngIf="child.title"
      [ngTemplateOutlet]="menuItemTemplate"
      [ngTemplateOutletContext]="{ item: child }"
    ></ng-container>
  </ng-container>
</ng-template>

<ng-template #menuItemTemplate let-item="item" let-parentItem="parentItem">
  <ng-container
    *ngIf="!item.permission"
    [ngTemplateOutlet]="menuItemInnerTemplate"
    [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
  ></ng-container>
  <ng-template *ngIf="item.permission" ngxPermissionsOnly="{{ item.permission }}">
    <ng-container
      [ngTemplateOutlet]="menuItemInnerTemplate"
      [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
    ></ng-container>
  </ng-template>
</ng-template>

<ng-template #menuItemInnerTemplate let-item="item" let-parentItem="parentItem">
  <li
    #listItem
    [attr.aria-haspopup]="true"
    [attr.data-menu-toggle]="getItemAttrSubmenuToggle(item)"
    [attr.data-ktmenu-submenu-mode]="item.mode"
    [attr.data-ktmenu-dropdown-toggle-class]="item['dropdown-toggle-class']"
    [ngClass]="getItemCssClasses(item)"
    data-placement="right"
  >
    <!-- if menu item hasn't submenu -->
    <a
      *ngIf="!item.submenu"
      #listItemLinkWithoutSubmenu
      [ngbTooltip]="theme.minimized ? item.tooltip : null"
      container="body"
      placement="right"
      class="menu-link menu-toggle"
      (mouseenter)="
        theme.minimized && handleMouseEnter(listItem, listItemLinkWithoutSubmenu, false)
      "
      (click)="navigate(item.page, item.type)"
    >
      <ng-container
        [ngTemplateOutlet]="menuItemTextTemplate"
        [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
      ></ng-container>
    </a>
    <!-- if menu item has sumnenu child  -->
    <a
      *ngIf="item.submenu"
      #listItemLinkWithSubmenu
      class="menu-link menu-toggle"
      (mouseenter)="theme.minimized && handleMouseEnter(listItem, listItemLinkWithSubmenu, true)"
      (click)="theme.minimized && handleMouseClick(listItem)"
    >
      <ng-container
        [ngTemplateOutlet]="menuItemTextTemplate"
        [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
      ></ng-container>
    </a>

    <!-- if menu item has submenu child then recursively call new menu item component -->
    <div *ngIf="item.submenu" class="menu-submenu">
      <span class="menu-arrow"></span>
      <div *ngIf="item['custom-class'] === 'menu-item--submenu-fullheight'" class="menu-wrapper">
        <!-- wrap submenu to full height -->
        <ng-container
          [ngTemplateOutlet]="menuSubmenuTemplate"
          [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
        ></ng-container>
      </div>
      <!-- normal submenu -->
      <ng-container
        *ngIf="item['custom-class'] !== 'menu-item--submenu-fullheight'"
        [ngTemplateOutlet]="menuSubmenuTemplate"
        [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
      >
      </ng-container>
    </div>
  </li>
</ng-template>

<ng-template #menuSubmenuTemplate let-item="item" let-parentItem="parentItem">
  <ul *ngIf="!theme?.minimized" class="menu-subnav">
    <ng-container *ngFor="let child of item.submenu">
      <ng-container
        *ngIf="child.section"
        [ngTemplateOutlet]="menuItemSectionTemplate"
        [ngTemplateOutletContext]="{ item: child, parentItem: item }"
      ></ng-container>
      <ng-container
        *ngIf="child.separator"
        [ngTemplateOutlet]="menuItemSeparatorTemplate"
        [ngTemplateOutletContext]="{ item: child, parentItem: item }"
      ></ng-container>
      <ng-container
        *ngIf="child.title"
        [ngTemplateOutlet]="menuItemTemplate"
        [ngTemplateOutletContext]="{ item: child, parentItem: item }"
      ></ng-container>
    </ng-container>
  </ul>
  <ul *ngIf="theme?.minimized" class="menu-subnav">
    <li *ngIf="item.tooltip" class="menu-title">{{ item.tooltip }}</li>
    <div class="subnav-container">
      <ng-container *ngFor="let child of item.submenu">
        <ng-container
          *ngIf="child.section"
          [ngTemplateOutlet]="menuItemSectionTemplate"
          [ngTemplateOutletContext]="{ item: child, parentItem: item }"
        ></ng-container>
        <ng-container
          *ngIf="child.separator"
          [ngTemplateOutlet]="menuItemSeparatorTemplate"
          [ngTemplateOutletContext]="{ item: child, parentItem: item }"
        ></ng-container>
        <ng-container
          *ngIf="child.title"
          [ngTemplateOutlet]="menuItemTemplate"
          [ngTemplateOutletContext]="{ item: child, parentItem: item }"
        ></ng-container>
      </ng-container>
    </div>
  </ul>
</ng-template>

<ng-template #menuItemTextTemplate let-item="item" let-parentItem="parentItem">
  <!-- if menu item has icon -->
  <i *ngIf="item.icon" class="menu-icon" [ngClass]="item.icon"></i>
  <span *ngIf="item.svgIcon" class="material-icons" style="color: white; margin: 3px 15px 0 0">
    {{ item.svgIcon }}
  </span>
  <span
    *ngIf="item.svgIconInline"
    class="svg-icon svg-icon-xl svg-icon-white"
    style="margin: 3px 12px 0 -5px"
    [inlineSVG]="item.svgIconInline"
  ></span>
  <!-- if menu item using bullet -->
  <i
    *ngIf="!item.submenu && parentItem && parentItem.bullet === 'dot'"
    class="menu-bullet menu-bullet-dot"
  >
    <span></span>
  </i>
  <i
    *ngIf="!item.submenu && parentItem && parentItem.bullet === 'line'"
    class="menu-bullet menu-bullet-line"
  >
    <span></span>
  </i>

  <!-- menu item title text -->
  <span class="menu-text" [translate]="item.translate">{{ item.title }}</span>
  <!-- menu item with badge -->
  <span *ngIf="item.badge" class="menu-label">
    <span class="label label-danger label-inline">{{ item.badge.value }}</span>
  </span>
  <!-- if menu item has submenu child then put arrow icon -->
  <i *ngIf="item.submenu" class="menu-arrow"></i>
</ng-template>

<ng-template #menuItemSeparatorTemplate let-item="item" let-parentItem="parentItem"> </ng-template>

<ng-template #menuItemSectionTemplate let-item="item" let-parentItem="parentItem">
  <li class="menu-section">
    <h4 class="menu-text">{{ item.section }}</h4>
    <i class="menu-icon flaticon-more-v2"></i>
  </li>
</ng-template>
